import React, { useEffect, useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BASE_API_URL from "../../apis/index";
import axios from "axios";
import { Button } from "@mui/material";
import styled from "styled-components";

export default function CompServicesSectionCRO({ compId }) {
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchService() {
      try {
        setLoading(true);

        const authToken = localStorage.getItem("authToken");

        const res = await axios.get(
          `${BASE_API_URL}/api/buyer/company/services/cro/${compId}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        let data = res.data;

        if (!data) {
          setService(null);
          return;
        }

        // Parse JSON fields safely
        try {
          data.service_catalog = data.service_catalog
            ? JSON.parse(data.service_catalog)
            : [];
        } catch {
          data.service_catalog = [];
        }

        try {
          data.geographic_reach = data.geographic_reach
            ? JSON.parse(data.geographic_reach)
            : [];
        } catch {
          data.geographic_reach = [];
        }

        setService(data);
      } catch (err) {
        console.error("Failed to fetch services", err);
        setService(null);
      } finally {
        setLoading(false);
      }
    }

    if (compId) fetchService();
  }, [compId]);

  if (loading || !service) return null;

  return (
    <Wrapper className="py-md-5 p-5 rounded-5 bg-light my-5">
      <div className="border rounded-4 overflow-hidden">

        <h5 className="txt_color_primary fw-medium px-3 py-4 bg-light">
          Services - Contract Research Organisation
        </h5>

        {service.service_catalog?.length > 0 && (
          <Row label="Service Catalog:">
            {service.service_catalog.map((item, i) => (
              <div className="Pill" key={i}>{item}</div>
            ))}
          </Row>
        )}

        {service.geographic_reach?.length > 0 && (
          <Row label="Geographic Reach:">
            {service.geographic_reach.map((item, i) => (
              <div className="Pill" key={i}>{item}</div>
            ))}
          </Row>
        )}

        {service.employee_count && (
          <Row label="No of employees in organization:">
            {service.employee_count}
          </Row>
        )}

        {service.qms_status && (
          <Row label="QMS Status:">
            <div className="Pill">
              {service.qms_status === "yes" ? "Yes" : "No"}
            </div>

            {service.qms_status === "yes" && service.qms_file && (
              <Button
                variant="outlined"
                color="warning"
                startIcon={<PictureAsPdfIcon />}
                href={`${BASE_API_URL}/uploads/user_srvc_docs/${service.qms_file}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: "none",
                  borderRadius: "5px",
                  padding: "5px 12px",
                  fontSize: "14px",
                }}
              >
                View File
              </Button>
            )}
          </Row>
        )}

        {service.sop_following && (
          <Row label="SOP Following:">
            <div className="Pill">
              {service.sop_following === "yes" ? "Yes" : "No"}
            </div>
          </Row>
        )}

        {service.past_audit_date && (
          <Row label="Past Audit Date:">
            {new Date(service.past_audit_date).toLocaleDateString()}
          </Row>
        )}

        {service.compliance_statement && (
          <Row label="Compliance Statement:">
            {service.compliance_statement}
          </Row>
        )}

      </div>
    </Wrapper>
  );
}

function Row({ label, children }) {
  if (!children) return null;

  return (
    <div className="w-100 border-top">
      <div className="d-flex align-items-start">
        <div className="w-25 bg-white p-3 fw-medium">
          {label}
        </div>
        <div className="w-75 p-3 d-flex flex-wrap gap-2">
          {children}
        </div>
      </div>
    </div>
  );
}

const Wrapper = styled.div`
  .Pill {
    background: white;
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #eee;
  }
`;